export const ASSET_DND_MIME = 'application/x-asset-dnd';

export const LEGACY_DND_MIME = 'application/json';

export interface AssetDragItem {
  id: string;
  src: string;
}

interface AssetDragPayload {
  items: AssetDragItem[];
}

export function serializePayload(items: AssetDragItem[]): string {
  const payload: AssetDragPayload = { items };
  return JSON.stringify(payload);
}

/**
 * dragenter/dragover 시점에는 dataTransfer.getData()가 동작하지 않으므로,
 * types 배열로 asset DnD 페이로드 여부를 식별한다.
 * OS 로컬 파일 드래그(types: ['Files', ...])와 명확히 분기하기 위함.
 */
export function hasAssetPayload(types: readonly string[]): boolean {
  return types.includes(ASSET_DND_MIME) || types.includes(LEGACY_DND_MIME);
}

export function parsePayload(
  dataTransfer: DataTransfer,
): AssetDragItem[] | null {
  const raw = dataTransfer.getData(ASSET_DND_MIME);
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as AssetDragPayload;
      if (Array.isArray(parsed.items) && parsed.items.length > 0) {
        return parsed.items;
      }
    } catch {
      /* invalid json */
    }
  }

  const legacy = dataTransfer.getData(LEGACY_DND_MIME);
  if (legacy) {
    try {
      const parsed = JSON.parse(legacy) as
        { id: string; src: string } | AssetDragPayload;
      if ('items' in parsed && Array.isArray(parsed.items)) {
        return parsed.items;
      }
      if ('id' in parsed && 'src' in parsed) {
        return [{ id: parsed.id, src: parsed.src }];
      }
    } catch {
      /* invalid json */
    }
  }

  return null;
}
